/**
 * Returns the message an SpAdmin API failure shows the user. Reads, in order, the
 * response's `errors` array (joined), its `error` string, a plain-text body that is
 * not an HTML page, then falls back to the HTTP status, the error's own message, and
 * finally a generic message.
 *
 * @param {Error & { status?: number, data?: unknown }} error
 * @returns {string}
 */
export function extractErrorMessage(error) {
  const data = error?.data;

  if (Array.isArray(data?.errors) && data.errors.length > 0) {
    return data.errors.join(", ");
  }

  if (typeof data?.error === "string" && data.error.length > 0) {
    return data.error;
  }

  if (typeof data === "string" && data.length > 0 && !data.trim().startsWith("<")) {
    return data;
  }

  if (error?.status) {
    return `Server responded with ${error.status}`;
  }

  return error?.message || "An error occurred. Please try again.";
}
